import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import {
  ContentFooter,
  ContentFooterFeedback
} from './../../model/content/contentfooter.model';

@Component({
  selector: 'ngc-feedback',
  templateUrl: './feedback.component.html'
})
export class FeedbackComponent implements OnInit, OnDestroy {
  public contentFeedback: ContentFooterFeedback;
  contentFooter: ContentFooter;
  contentServiceHeaderFooterService: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef,
    private loggingService: LoggingService
  ) {
    this.contentFeedback = new ContentFooterFeedback();
  }

  ngOnInit() {
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterService =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.contentFeedback = data.footer.feedback;
                this.contentFooter = data.footer;
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterService) {
      this.contentServiceHeaderFooterService.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
